/** * * 文字-单文字控件 * */

<template lang="pug">
.SINGLETEXT
  .title  {{cont.title}}
  .cont {{cont.stem}}
</template>
<script>
export default {
  props: ["cont"],
  created() {
    console.log(this.cont);
  }
};
</script>

<style lang="stylus" scoped>
.SINGLETEXT
  .title
    font-size 20px
    font-family MicrosoftYaHeiUI-Bold
    font-weight bold
    color rgba(42, 46, 54, 0.8)
    line-height 25px
  .cont
    font-size 16px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 28px
    margin-top 12px
</style>
